module.exports = __webpack_public_path__ + "img/invoice_request_ru.5092173c.svg";